<template>
  <div class="header">
    <div class="headers">
       <img src="@/assets/logo.png" class="logo" alt="">
       <div class="nav">
         <div class="navs" @click="routers(item)" :class="[navSelect==item.id?'select':'']" v-for="(item,i) in navArr" :key="i">
            {{item.title}}
         </div>
       </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  export default {
    computed:{
      ...mapGetters(['navSelect']),
    },
     data(){
      return{
         navArr:[
          {id:1,title:"网站首页",url:"/",newPage:false},
          {id:2,title:"测评中心",url:"/Appraisal",newPage:false},
          {id:3,title:"志愿导航",url:"/Volunteer",newPage:true},
          {id:6,title:"综合查询",url:"/comprehensive",newPage:true},
          {id:4,title:"考研专项",url:"/",newPage:false},
          {id:5,title:"关于我们",url:"/aboutus",newPage:false},
          // {id:6,title:"招商加盟",url:"/",newPage:false},

         ],
      }
     },
     methods: {
       routers(item){
          this.$store.dispatch("set_nav",item.id)
          if(item.newPage==true){
            const routerUrl = this.$router.resolve({
              path:item.url
            })
            window.open(routerUrl.href,"_blank")
          }else{
            this.$router.push({
              path:item.url
            })
          }
       },
    }
  }
</script>

<style lang="scss" scoped>
  .head{
    width: 100%;
    background: #F3F4F7;
    height: 42px;
  }
.nav{
  display: flex;
  align-items: center;
  margin-left: 193px;
  .navs{
    width: 136px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 22px;
  }
  .select{
    background: url("../assets/navbg.png") no-repeat;
    cursor: pointer;
    color: #fff!important;
  }
  .navs:hover{
    color: #2AA38B;
  }
}
.header{
  .headers{
    width: 1250px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .logo{
      width: 218px;
      height: 77px;
      cursor: pointer;
    }
  }
  width: 100%;
  height: 130px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue